import EditNoteIcon from '@mui/icons-material/EditNote';
import { Button, IconButton, Tooltip } from '@mui/material';
import { FormattedMessage } from 'react-intl';

type FormActionsMuiDraftActionProps = {
  isCompact: boolean;
  disabled: boolean;
  onDraft: () => void;
};

/** Draft action as a text button or compact icon button. */
export function FormActionsMuiDraftAction({
  isCompact,
  disabled,
  onDraft,
}: FormActionsMuiDraftActionProps) {
  if (isCompact) {
    return (
      <Tooltip title={<FormattedMessage id="common.actions.draft" defaultMessage="Borrador" />}>
        <span>
          <IconButton color="secondary" onClick={onDraft} disabled={disabled} size="small">
            <EditNoteIcon />
          </IconButton>
        </span>
      </Tooltip>
    );
  }

  return (
    <Button color="secondary" startIcon={<EditNoteIcon />} onClick={onDraft} disabled={disabled}>
      <FormattedMessage id="common.actions.draft" defaultMessage="Borrador" />
    </Button>
  );
}
